import MUIDataTable from 'mui-datatables'
import { Link } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import "../../../css/Users.css"
import { containsPermission, logOut } from '../../helper';
import React, {Component} from 'react';
import { Form, Col } from 'react-bootstrap';


const columns = [
    {
        "name" : "display_name",
        "label" : "მდგომარეობა",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "in_group",
        "label" : "ჯგუფში",
        "options": {
            "sort" : true
        }
    },
    
]
class Stages extends Component {
    constructor(){
        super();
        this.onRowsDelete = this.onRowsDelete.bind(this);
        this.onRowSelectionChange = this.onRowSelectionChange.bind(this);
        this.state = {
            data:[],
            options:{
                filterType: 'checkbox',
                selectableRowsHeader:false,
                expandableRowsHeader:false,
                viewColumns:false,
                print:false,
                filter:false,
                selectableRows:'multiple',
                onRowsDelete:this.onRowsDelete,
                onRowSelectionChange:this.onRowSelectionChange
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'პრობლემა წარმატებით ჩაემატა'
            }
        }
    }
    componentDidMount(){
        this.fetch_stages();
    }


    fetch_stages(){
        axiosInstance.get('tickets/stages')
        .then(response=>{
            let stages_array = [];
            response.data.data.forEach(element => {
                stages_array.push({
                    id : element.id,
                    display_name : element.display_name,
                    in_group:element.in_group
                })
            });
            this.setState({
                data:stages_array 
            })
        })
        .catch(err => {
            if(err.response.status === 401){
                logOut(this.props);
            }
        })
    }

    on_fetch_stages(data){
        this.setState({
            data:data
        })
    }

    onRowSelectionChange(){
        this.setState({
            ...this.state,
            response:{
                isInvalid:false,
                isValid:false
            }
        })
    }
    onRowsDelete(rowsDeleted){
        let id = this.state.data[rowsDeleted.data[0].dataIndex].id
        axiosInstance.delete('tickets/stages/'+id)
        .then(response=>{
            this.fetch_stages();
            this.setState({
                response:{
                    ...this.state.response,
                    isValid:true,
                    message:response.data.message
                }
            })
        })
        .catch(error => {
            if(error.response.status == 400){
                this.on_bad_request(error.response.data);
            }
        });

        return true;
        
    }
    on_bad_request(data){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:data.messages
            }
        })
    }


    render(){

        let add_user = null;
        if(containsPermission(this.props.role_permissions,'types.add')){
            add_user = <Link  to = "/stages/new_stage"  id = "create_new_btn" className="btn btn-dark" > ახლის დამატება</Link>;
        }
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    problem="text"
                                    name="problem"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                {add_user}
                <MUIDataTable
                    data={this.state.data}
                    columns={columns}
                    options={this.state.options}
                />
            </div>
        )
    }
}
export default Stages;